import workSamples from '@/routes/WorkSamples';

export default workSamples;
